<template>
  <div class="paginationSet">
    <div class="verticallyCenter content-c">
      <single-input
        class="width58"
        :value.sync="paginationTopVal"
        :disabled="paginationPositionVal!='top' && paginationPositionVal!='leftTop' &&paginationPositionVal!='rightTop'"
        inputSuffixs="px"
      />
    </div>
    <div class="verticallyCenter">
      <single-input
        class="width58"
        :disabled="paginationPositionVal!='left' && paginationPositionVal!='leftTop' && paginationPositionVal!='leftBottom'"
        :value.sync="paginationLeftVal"
        inputSuffixs="px"
      />
      <div class="pos-style-box">
        <div class="pos-style-item" 
          v-for="item in positionList"
          :key="item.value"
          :class="item.value == '' ? 'none' : ''"
          @click="changePosition(item.value)"
          ><span :class="[item.value == paginationPositionVal ? 'active item' : 'item']"></span>
        </div>
      </div>
      <single-input
        class="width58"
        :disabled="paginationPositionVal!='right' && paginationPositionVal!='rightTop' && paginationPositionVal!='rightBottom'"
        :value.sync="paginationRightVal"
        inputSuffixs="px"
      />
<!--      <el-input-->
<!--        class="width58"-->
<!--        type="number"-->
<!--        v-inputHandle="{ this1, type: paginationPositionVal=='right' ? 'paginationRightVal' : ''}"-->
<!--        v-model="paginationRightVal"-->
<!--        :disabled="paginationPositionVal!='right' && paginationPositionVal!='rightTop' && paginationPositionVal!='rightBottom'"-->
<!--      >-->
<!--        <template slot="suffix">-->
<!--          <span class="suffix_text">px</span>-->
<!--        </template>-->
<!--      </el-input>-->
    </div>
    <div class="verticallyCenter content-c">
      <single-input
        class="width58"
        :value.sync="paginationBottomVal"
        :disabled="paginationPositionVal!='bottom' && paginationPositionVal!='leftBottom' &&paginationPositionVal!='rightBottom'"
        :min="-100"
        inputSuffixs="px"
      />
<!--      <el-input-->
<!--        class="width58"-->
<!--        type="number"-->
<!--        v-inputHandle="{ this1, type: 'paginationBottomVal' }"-->
<!--        v-model="paginationBottomVal"-->
<!--        :disabled="paginationPositionVal!='bottom' && paginationPositionVal!='leftBottom' &&paginationPositionVal!='rightBottom'"-->
<!--        :min="-100"-->
<!--      >-->
<!--        <template slot="suffix">-->
<!--          <span class="suffix_text">px</span>-->
<!--        </template>-->
<!--      </el-input>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "paginationSet",
  props: {
    paginationPosition: {
      type: String,
      required: true
    },
    paginationLeft: {
      type: [Number,String],
      required: false
    },
    paginationRight: {
      type: [Number,String],
      required: false
    },
    paginationTop: {
      type: [Number,String],
      required: false
    },
    paginationBottom: {
      type: [Number,String],
      required: false
    },
  },
  data() {
    return {
      this1: this,
      positionList: [
        { label: "左上", value: "leftTop" },
        { label: "顶部", value: "top" },
        { label: "右上", value: "rightTop" },
        { label: "左侧", value: "left" },
        { label: "", value: "" },
        { label: "右侧", value: "right" },
        { label: "左下", value: "leftBottom" },
        { label: "底部", value: "bottom" },
        { label: "右下", value: "rightBottom" },
      ]
    }
  },
  computed: {
    paginationPositionVal: {
      get() {
        return this.paginationPosition
      },
      set(newVal) {
        this.$emit("update:paginationPosition", newVal)
      }
    },
    paginationTopVal: {
      get() {
        return this.paginationTop
      },
      set(newVal) {
        this.$emit("update:paginationTop", newVal)
      }
    },
    paginationBottomVal: {
      get() {
        return this.paginationBottom
      },
      set(newVal) {
        this.$emit("update:paginationBottom", newVal)
      }
    },
    paginationLeftVal: {
      get() {
        return this.paginationLeft
      },
      set(newVal) {
        this.$emit("update:paginationLeft", newVal)
      }
    },
    paginationRightVal: {
      get() {
        return this.paginationRight
      },
      set(newVal) {
        this.$emit("update:paginationRight", newVal)
      }
    },
  },
  mounted() {},
  methods: {
    changePosition(val) {
      if(!val) return
      this.paginationPositionVal = val
    }
  }
}
</script>

<style scoped lang="scss">
.width58 {
  width: 58px;
}
.paginationSet {
  padding: 0 10px;
}
.pos-style-box {
  width: 58px;
  height: 58px;
  border: 0.7px solid var(--borderColorFour);
  border-radius: 4px;
  margin: 8px;
  padding: 2px;
  box-sizing: border-box;
  font-size: 0;
  .pos-style-item {
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: calc((100% - 12px) / 3);
    height: calc((100% - 12px) / 3);
    padding: 2px;
    margin: 2px;
    cursor: pointer;
    &.none {
      opacity: 0;
      cursor: default;
    }
    .item {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 2px;
      height: 2px;
      background: var(--iconColor);
      &:hover {
        width: 10px;
        height: 10px;
        border-radius: 2px;
        background: var(--themeColorDisabled);
      }
      &.active {
        width: 10px;
        height: 10px;
        border-radius: 2px;
        background: var(--themeColor);
      }
    }
  }
}
::v-deep .el-input.el-input__inner,
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: var(--inputBg);
  border-color: var(--inputBg);
}

</style>
